import styles from './WithdrawRequest.module.scss';
import { useGetWithdrawRequest } from '../../hooks/useGetWithdrawRequest';
import { useParams } from 'react-router-dom';
import { BackArrow } from '../Shared/BackArrow/BackArrow';
import { Profile } from './components/Profile/Profile';
import { UserDetails } from './components/UserDetails/UserDetails';
import { Wallet } from './components/Wallet/Wallet';
import { TransactionHistory } from './components/TransactionHistory/TransactionHistory';
import { GameHistory } from './components/GameHistory/GameHistory';

export const WithdrawRequest = () => {
    const { id } = useParams();
    if (!id) return null;

    const { withdrawRequestData, isLoading } = useGetWithdrawRequest({ id });

    if (isLoading || !withdrawRequestData) return null;

    return (
        <div className={styles.container}>
            <BackArrow />

            <div className={styles.row}>
                <div className={styles.block}>
                    <Profile userId={withdrawRequestData?.userId} withdrawRequestId={withdrawRequestData?.id} />
                    <Wallet userId={withdrawRequestData?.userId} />
                    <UserDetails userId={withdrawRequestData?.userId} withdrawRequestId={withdrawRequestData?.id} />
                </div>

                <div className={styles.block}>
                    <GameHistory userId={withdrawRequestData.userId} />
                </div>

                <div className={styles.block}>
                    <TransactionHistory userId={withdrawRequestData.userId} />
                </div>
            </div>
        </div>
    );
};
